// The app's modes and its header brand.
//
// IBCS (air and missile defense) and JIATF-401 (counter-small-UAS) each own a
// deployment-plans hub and a dynamic-engagement page; they share the screens and
// differ by the profile they plan with ('amd' | 'cuas'). The mode comes ONLY from
// the URL: nothing is stored, so leaving a mode's pages by any route (menu, back
// button, typed URL, a link) shows the TMPC NEXTGEN brand again. Every other page
// is TMPC NEXTGEN, always (utils/__tests__/appMode.test.js checks every menu destination).

export const TMPC_BRAND = 'TMPC NEXTGEN';

export const MODES = {
  ibcs: {
    key: 'ibcs', brand: 'IBCS', profile: 'amd',
    title: 'Integrated Battle Command System: air and missile defense',
    plansPath: '/deployment-plans', engagementPath: '/dynamic-engagement',
  },
  jiatf: {
    key: 'jiatf', brand: 'JIATF-401', profile: 'cuas',
    title: 'Joint Interagency Task Force 401: counter-small-UAS',
    plansPath: '/jiatf-401/deployment-plans', engagementPath: '/jiatf-401/dynamic-engagement',
  },
};

const normalise = (pathname) => (pathname || '/').replace(/\/+$/, '') || '/';

/** The mode whose page this is, or null for every other page. */
export function modeForPath(pathname) {
  const path = normalise(pathname);
  return Object.values(MODES).find((m) => path === m.plansPath || path === m.engagementPath) || null;
}

/** The header brand for a page: IBCS, JIATF-401, or TMPC NEXTGEN everywhere else. */
export const brandForPath = (pathname) => modeForPath(pathname)?.brand || TMPC_BRAND;

/** The mode a site or plan belongs to, from its defense profile (anything but 'cuas' is IBCS). */
export const modeForProfile = (profile) => (profile === 'cuas' ? MODES.jiatf : MODES.ibcs);

/**
 * Where an engagement page must move to so its plan and its header agree: the
 * plan's own mode's engagement page when it was opened under the other mode, else null.
 */
export function engagementRedirect(mode, plan) {
  if (!plan) return null;
  const own = modeForProfile(plan.defense_profile);
  return own.key === mode.key ? null : own.engagementPath;
}
